export const formatNumber = (number: number) => ('0' + number).slice(-2)

export const getColSpan = (
  maxColElements: number = 4,
  minColElements: number = 2,
  totalItems: number
) => {
  if (totalItems === 0) return 4

  // If 1 or 2 items, use minColElements
  // Otherwise, max 4 elements per row
  const columns =
    totalItems <= 2 ? minColElements : Math.min(totalItems, maxColElements)
  const gridColSpan = 12 / columns

  return gridColSpan
}

export const getUserInitials = (user?: {
  first_name: string | null
  last_name: string | null
}) => {
  if (!user) return 'UU'

  const first = user.first_name?.trim()?.charAt(0) ?? ''
  const last = user.last_name?.trim()?.charAt(0) ?? ''
  const initials = (first + last).toUpperCase()

  return initials || 'UU'
}
